import { Chip, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomNewButton from "../../newComponent/themeprovider/button/CustomNewButton";
import CustomPopup from "../../../components/CustomPopup";
import CreateAssignmentForm from "./AddAssignment";
import { DataGrid } from "@mui/x-data-grid";
import CustomNoRowsOverlay from "../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import { ThemeProvider } from "@emotion/react";
import mainTheme from "../../newComponent/themeprovider/mainTheme/MainTheme";
import MainCard from "../../../components/Maincard";
import HeadingCard from "../../newComponent/NewCardsComp/HeadingCard";
import { deleteAssignment, fetchAssignmentByUser } from "./services";
import { render } from "@testing-library/react";
import { fDate } from "./../../../utils/formatTime";
import { min, set } from "date-fns";
import CustomSnackbar from "../../components/ui-component/snackbar/CustomSnackbar";
import LoaderComp from "../../newComponent/LoaderComp/Loader";
import DescriptionPopup from "../packages/DescriptionPopup";
import EditIconcomp from "../../newComponent/iconsComp/EditIconcomp";
import DenyIcon from "../../newComponent/iconsComp/DenyIcon";
import EditAssignmentForm from "./EditAssignmentForm";
import ConfirmationPopup from "../../../components/ConfirmationPopup";
import { fi } from "date-fns/locale";

export default function AssignMentDetails() {
  const userId = localStorage.getItem("userId");
  const userRole = localStorage.getItem("userRole");

  const [openAddForm, setOpenAddForm] = React.useState(false);
  const [assignmentsDetails, setAssignmentsDetails] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [descriptionPopupOpen, setDescriptionPopupOpen] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState("");

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const [openEditForm, setOpenEditForm] = React.useState(false);
  const [editData, setEditData] = React.useState({});
  const [openDeleleteForm, setOpenDeleleteForm] = React.useState(false);

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleOpen = () => setOpenAddForm(true);
  const handleClose = () => setOpenAddForm(false);

  const handleOpenEdit = (rowData) => {
    setOpenEditForm(true);
    setEditData(rowData);
  };
  const handleCloseEdit = () => setOpenEditForm(false);

  const handleOpenDelete = (rowData) => {
    setOpenDeleleteForm(true);
    setEditData(rowData);
  };
  const handleCloseDelete = () => setOpenDeleleteForm(false);

  const columns = [
    {
      field: "action",
      headerName: "Action",
      width: 100,
      minWidth: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        userRole==="trainer" && ( 
        <div style={{ display: "flex", gap: "10px" }}>
          <EditIconcomp
            fontSize="0.9rem"
            tooltipTitle="Edit"
            onClick={() => handleOpenEdit(params.row)}
          />
          <DenyIcon
            fontSize="0.9rem"
            tooltipTitle="Delete"
            onClick={() => handleOpenDelete(params.row)}
          />
        </div>
        )
      ),
    },
    {
field: "test_type_id",
      headerName: "Test Type",
      width: 130,
      minWidth: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <div>
          <Typography>{params.row.test_type_id?.name}</Typography>
        </div>
      ),
    },
    {
      field: "packageName",
      headerName: "Package Name",
      width: 230,
      minWidth: 230,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <Typography>{params?.row?.package_id?.package_name}</Typography>
      ),
    },
    {
      field: "assignmentName",
      headerName: "Assignment Name",
      width: 200,
      minWidth: 200,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <div>
          <Typography>{params.row.title}</Typography>
        </div>
      ),
    },
    {
      field: "assignmentType",
      headerName: "Assignment Type",
      width: 130,
      minWidth: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <div>
          <Typography>{params.row.assignment_type}</Typography>
        </div>
      ),
    },
    {
      field: "assignmentDescription",
      headerName: "Description/Instruction",
      width: 250,
      minWidth: 250,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const description = params?.row?.description || "";

        if (!description) return <div>-</div>;

        const shouldTruncate = description.length > 30;

        return (
          <Typography>
            {shouldTruncate ? description.slice(0, 30) + "..." : description}
            {shouldTruncate && (
              <span
                style={{
                  color: "#1976d2",
                  cursor: "pointer",
                  marginLeft: "5px",
                }}
                onClick={() => {
                  setSelectedDescription(description);
                  setDescriptionPopupOpen(true);
                }}
              >
                See more
              </span>
            )}
          </Typography>
        );
      },
    },
   
    {
      field: "marks",
      headerName: "Marks",
      width: 130,
      minWidth: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <div>
          <Typography>{params.row.max_marks}</Typography>
        </div>
      ),
    },
    {
      field: "attemptLimit",
      headerName: "Attempt Limit",
      width: 130,
      minWidth: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <div>
          <Typography>{params.row.attempt_limit}</Typography>
        </div>
      ),
    },
    {
      field: "document",
      headerName: "Assignment File",
      width: 130,
      minWidth: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => <div><Typography style={{color:"#1985DA",cursor:"pointer"}} onClick={() => window.open(params?.row?.assignment_link, "_blank")}>Attached  File</Typography></div>,
    },
     {
      field: "createdAt",
      headerName: "Created Date",
      width: 130,
      minWidth: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => <Typography>{fDate(params.value)}</Typography>,
    },
     {
      field:"createdBy",
      headerName:"Created By",
      width:130,
      minWidth:130,
      align:"center",
      headerAlign:"center",
      renderCell:(params) => <div><Typography>{params?.row?.created_by?.first_name} {params?.row?.created_by?.last_name}</Typography></div>
    },
    {
      field: "updatedAt",
      headerName: "Updated Date",
      width: 130,
      minWidth: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => <Typography>{fDate(params.value)}</Typography>,
    },
    {
      field:"updatedBy",
      headerName:"Updated By",
      width:130,
      minWidth:130,
      align:"center",
      headerAlign:"center",
      renderCell:(params) => <div><Typography>{params?.row?.updated_by?.first_name} {params?.row?.updated_by?.last_name}</Typography></div>
    },
   
    {
      field: "assignmentStatus",
      headerName: "Assignment Status",
      width: 130,
      minWidth: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <div>
          <Chip
            label={params.row.is_active === 1 || params.row.is_active === true  ? "Active" : "Inactive"}
            size="small"
            variant="contained"
            color={params.row.is_active === 1 || params.row.is_active === true ? "secondary" : "error"}
          />
        </div>
      ),
    },
  ];

  useEffect(() => {
    setLoading(true);
    const getAssignment = async () => {
      try {
        const data = await fetchAssignmentByUser(userId);

        if (data?.status === 200) {
          setAssignmentsDetails(data?.data);
          setLoading(false);
        } else {
          setAssignmentsDetails([]);
          setLoading(false);
          showSnackbar(data?.message, "error");
        }
      } catch (error) {
        setLoading(false);
        console.error("Error fetching assignment:", error);
      }
    };

    if (userId) {
      getAssignment();
    }
  }, [userId]);

  const handleUpdateStatus = async () => {
    const requestData = {
      is_active: 0,
      is_deleted: 1,
    };
    try {
      const response = await deleteAssignment({
        requestData: requestData,
        id: editData?.id,
      });

      if (response?.status === 200) {
        showSnackbar("Assignment Deleted Successfully");
        setTimeout(() => window.location.reload(), 1200);
      } else {
        showSnackbar(response?.message || "Delete Failed", "error");
      }
    } catch (error) {
      console.error("Error deleting assignment:", error);
      showSnackbar("Delete Failed", "error");
    }
  };

  return (
    <>
      <LoaderComp isLoading={loading} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={3}>
          <HeadingCard label="Assignment Details" />
        </Grid>
        {userRole==="trainer" && ( 
        <Grid item xs={12} sm={6} md={9} textAlign="right">
          <CustomNewButton
            label="Create Assignment"
            onClick={handleOpen}
            disabled={false}
            size="small"
          />
        </Grid>
        )}
        <Grid item xs={12}>
          <MainCard>
            {" "}
            <DataGrid
              rows={assignmentsDetails}
              columns={columns}
              slots={{
                noRowsOverlay: CustomNoRowsOverlay,
              }}
              autoHeight
              // getRowHeight={() => "auto"}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 25,
                  },
                },
              }}
              pageSizeOptions={[25, 50, 100]}
            />
          </MainCard>
        </Grid>
      </Grid>
      <CustomPopup
        open={openAddForm}
        onClose={handleClose}
        maxWidth="md"
        //title='My Task Report'
        component={<CreateAssignmentForm onClose={handleClose} />}
      />

      <CustomPopup
        open={openEditForm}
        onClose={handleCloseEdit}
        maxWidth="md"
        //title='My Task Report'
        component={
          <EditAssignmentForm onClose={handleCloseEdit} rowData={editData} />
        }
      />

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />

      <DescriptionPopup
        open={descriptionPopupOpen}
        description={selectedDescription}
        onClose={() => setDescriptionPopupOpen(false)}
      />

      <ConfirmationPopup
        open={openDeleleteForm}
        onClose={handleCloseDelete}
        title="Delete Assignment"
        textBody="Are you sure you want to delete this assignment?"
        maxWidth="xs"
        showDivider={true}
        handleUpdateStatus={handleUpdateStatus}
      />
    </>
  );
}
